import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-connectionerror.content.json';

@Component({
    selector: 'conversational-chat-connectionerror',
    templateUrl: './conversational-chat-connectionerror.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalChatConnectionerrorComponent {
    private readonly apContentService = inject(ApContentService);

    constructor() {
        this.apContentService.addContentItems(content);
    }
}
